// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from PriceSummaryList.module.scss  */
.PriceSummaryList-module-Root_1R- {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--display-font-family); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/PriceSummaryList/PriceSummaryList.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uCAAuC,EAAE","sourcesContent":["/*  imported from PriceSummaryList.module.scss  */\n.PriceSummaryList-module-Root_1R- {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-family: var(--display-font-family); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
